import { DeepReadonly } from 'vue';
import { Property } from '../generated/ChartServer';

export const propertySorter = (p1: DeepReadonly<Property>, p2: DeepReadonly<Property>): number => {
  const t1 = p1.title ?? '';
  const t2 = p2.title ?? '';
  return t1 < t2 ? -1 : t1 > t2 ? 1 : 0;
};
